const hosts = document.querySelectorAll('[data-floating-pattern]')

if (hosts.length) {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)')

  fetch('assets/img/patterns/about-floating-small.svg')
    .then((response) => {
      if (!response.ok) throw new Error('Pattern unavailable')
      return response.text()
    })
    .then((markup) => {
      const template = new DOMParser().parseFromString(
        markup,
        'image/svg+xml'
      ).documentElement
      const sourceCurves = Array.from(template.querySelectorAll('path')).map(
        (path) => {
          const length = path.getTotalLength()
          const steps = Math.ceil(length / 10)
          const points = Array.from({ length: steps + 1 }, (_, index) =>
            path.getPointAtLength((length * index) / steps)
          )
          const x = Math.min(...points.map((point) => point.x))
          const y = Math.min(...points.map((point) => point.y))
          return {
            bounds: {
              x,
              y,
              width: Math.max(...points.map((point) => point.x)) - x,
              height: Math.max(...points.map((point) => point.y)) - y,
            },
            points,
          }
        }
      )
      hosts.forEach((host) => {
        const layer = document.createElement('div')
        layer.className = 'gestos-floating-pattern'
        layer.setAttribute('aria-hidden', 'true')
        const track = document.createElement('div')
        track.className = 'gestos-pattern-track'
        layer.appendChild(track)
        host.prepend(layer)
        host.classList.add('gestos-pattern-ready')
        let shapes = []
        let bodies = []
        let frame = 0
        let hovering = false
        let pointer = { x: 0, y: 0 }
        let lastUpdate = 0
        const logo = host.querySelector('.gestos-home-brand-logo')
        let logoFrame = 0
        let logoStrength = 0
        let logoTarget = 0
        let lensX = 0
        let lensY = 0
        let lensRadius = 65
        let lensTargetX = 0
        let lensTargetY = 0
        const logoPaths = Array.from(logo?.querySelectorAll('path') || []).map(
          (path) => {
            const original = path.getAttribute('d')
            const contours = original
              .split(/(?=M)/)
              .filter(Boolean)
              .map((contour) => {
                const measure = document.createElementNS(
                  'http://www.w3.org/2000/svg',
                  'path'
                )
                measure.setAttribute('d', contour)
                const length = measure.getTotalLength()
                const steps = Math.max(2, Math.ceil(length / 2))
                const points = Array.from({ length: steps + 1 }, (_, index) => {
                  const point = measure.getPointAtLength(
                    (length * index) / steps
                  )
                  return { x: point.x, y: point.y }
                })
                return { points, closed: /z\s*$/i.test(contour) }
              })
            return { path, original, contours }
          }
        )
        if (logo) logo.style.filter = 'none'
        const renderLogo = () => {
          logoPaths.forEach(({ path, original, contours }) => {
            if (!logoStrength) {
              path.setAttribute('d', original)
              return
            }
            const warped = contours
              .map(
                ({ points, closed }) =>
                  points
                    .map((point, index) => {
                      const dx = point.x - lensX
                      const dy = point.y - lensY
                      const proximity = Math.max(
                        0,
                        1 - Math.hypot(dx, dy) / lensRadius
                      )
                      const falloff =
                        proximity * proximity * (3 - 2 * proximity)
                      const force = falloff * logoStrength * 0.2
                      return (
                        (index ? 'L' : 'M') +
                        (point.x + dx * force).toFixed(2) +
                        ',' +
                        (point.y + dy * force).toFixed(2)
                      )
                    })
                    .join('') + (closed ? 'Z' : '')
              )
              .join('')
            path.setAttribute('d', warped)
          })
        }
        const animateLogo = () => {
          logoStrength += (logoTarget - logoStrength) * 0.075
          lensX += (lensTargetX - lensX) * 0.14
          lensY += (lensTargetY - lensY) * 0.14
          const positionSettled =
            Math.hypot(lensTargetX - lensX, lensTargetY - lensY) < 0.2
          if (positionSettled) {
            lensX = lensTargetX
            lensY = lensTargetY
          }
          if (Math.abs(logoTarget - logoStrength) < 0.002)
            logoStrength = logoTarget
          renderLogo()
          logoFrame =
            logoStrength === logoTarget && positionSettled
              ? 0
              : requestAnimationFrame(animateLogo)
        }
        const setLogoTarget = (strength) => {
          if (!logo) return
          logoTarget = reducedMotion.matches ? 0 : strength
          if (!logoFrame) logoFrame = requestAnimationFrame(animateLogo)
        }
        const updateLens = (bounds) => {
          if (!logo) return
          lensTargetX = ((pointer.x - bounds.left) * 660) / bounds.width
          lensTargetY = ((pointer.y - bounds.top) * 582.28) / bounds.height
          lensRadius = (65 * 660) / bounds.width
          if (!logoStrength) {
            lensX = lensTargetX
            lensY = lensTargetY
          }
        }

        const reset = () => {
          hovering = false
          setLogoTarget(0)
          if (reducedMotion.matches) {
            cancelAnimationFrame(frame)
            frame = 0
            bodies.forEach((body) => {
              body.x = 0
              body.y = 0
              body.scale = 1
            })
            shapes.forEach((shape) => shape.style.removeProperty('transform'))
          }
        }
        const resize = () => {
          reset()
          const columns = Math.ceil(host.clientWidth / 80) + 8
          const rows = Math.ceil(host.clientHeight / 80) + 8
          track.style.gridTemplateColumns = 'repeat(' + columns + ', 80px)'
          const fragment = document.createDocumentFragment()
          for (let i = 0; i < columns * rows; i++) {
            const cell = document.createElement('div')
            cell.className = 'gestos-pattern-tile'
            const row = Math.floor(i / columns)
            const column = i % columns
            const angle = ((row + column) % 4) * 90
            cell.style.transform = 'rotate(' + angle + 'deg)'
            const tile = template.cloneNode(true)
            tile.setAttribute('focusable', 'false')
            cell.appendChild(tile)
            fragment.appendChild(cell)
          }
          track.replaceChildren(fragment)
          shapes = Array.from(track.querySelectorAll('svg > path'))
          const unit = 80 / 281.6
          bodies = shapes.map((shape, index) => {
            const tileIndex = Math.floor(index / 3)
            const row = Math.floor(tileIndex / columns)
            const column = tileIndex % columns
            const angle = (((row + column) % 4) * Math.PI) / 2
            const cos = Math.cos(angle)
            const sin = Math.sin(angle)
            const source = sourceCurves[index % 3]
            const centerX = source.bounds.x + source.bounds.width / 2
            const centerY = source.bounds.y + source.bounds.height / 2
            const tileX = (centerX - 277.38 / 2) * unit
            const tileY = (centerY - 281.6 / 2) * unit
            return {
              shape,
              cos,
              sin,
              unit,
              baseX: column * 80 + 40 + tileX * cos - tileY * sin,
              baseY: row * 80 + 40 + tileX * sin + tileY * cos,
              points: source.points.map((point) => ({
                x:
                  ((point.x - centerX) * cos - (point.y - centerY) * sin) *
                  unit,
                y:
                  ((point.x - centerX) * sin + (point.y - centerY) * cos) *
                  unit,
              })),
              x: 0,
              y: 0,
              scale: 1,
              strength: 0,
            }
          })
        }
        const repelCurves = () => {
          const origin = track.getBoundingClientRect()
          const area = host.getBoundingClientRect()
          let moving = false
          bodies.forEach((body) => {
            const dx = origin.left + body.baseX - pointer.x
            const dy = origin.top + body.baseY - pointer.y
            const distance = Math.hypot(dx, dy)
            const proximity = hovering ? Math.max(0, 1 - distance / 110) : 0
            body.strength = proximity * proximity * (3 - 2 * proximity)
            const targetX = (dx / Math.max(distance, 1)) * body.strength * 18
            const targetY = (dy / Math.max(distance, 1)) * body.strength * 18
            body.x += (targetX - body.x) * 0.1
            body.y += (targetY - body.y) * 0.1
            body.scale += (1 + body.strength * 0.48 - body.scale) * 0.14
          })
          const active = bodies.filter((body) => {
            const x = origin.left + body.baseX
            const y = origin.top + body.baseY
            return (
              x > area.left - 180 &&
              x < area.right + 180 &&
              y > area.top - 180 &&
              y < area.bottom + 180
            )
          })
          const updateGeometry = (body) => {
            body.world = body.points.map((point) => ({
              x: body.baseX + body.x + point.x * body.scale,
              y: body.baseY + body.y + point.y * body.scale,
            }))
            body.minX = Math.min(...body.world.map((point) => point.x))
            body.maxX = Math.max(...body.world.map((point) => point.x))
            body.minY = Math.min(...body.world.map((point) => point.y))
            body.maxY = Math.max(...body.world.map((point) => point.y))
          }
          const shift = (body, x, y) => {
            body.x += x
            body.y += y
            body.minX += x
            body.maxX += x
            body.minY += y
            body.maxY += y
            body.world.forEach((point) => {
              point.x += x
              point.y += y
            })
          }
          active.forEach(updateGeometry)
          for (let pass = 0; pass < 10; pass++) {
            let contacts = 0
            for (let i = 0; i < active.length; i++) {
              const a = active[i]
              for (let j = i + 1; j < active.length; j++) {
                const b = active[j]
                const clearance = 6 * a.unit * (a.scale + b.scale) + 3.5
                if (
                  a.maxX + clearance < b.minX ||
                  b.maxX + clearance < a.minX ||
                  a.maxY + clearance < b.minY ||
                  b.maxY + clearance < a.minY
                )
                  continue
                let closest = clearance * clearance
                let nx = 0
                let ny = 0
                a.world.forEach((pa) => {
                  b.world.forEach((pb) => {
                    const dx = pa.x - pb.x
                    const dy = pa.y - pb.y
                    const squared = dx * dx + dy * dy
                    if (squared < closest) {
                      closest = squared
                      nx = dx
                      ny = dy
                    }
                  })
                })
                if (closest >= clearance * clearance) continue
                const distance = Math.sqrt(closest)
                if (distance < 0.001) {
                  nx = a.baseX + a.x - b.baseX - b.x
                  ny = a.baseY + a.y - b.baseY - b.y
                }
                const normal = Math.hypot(nx, ny) || 1
                const correction = clearance - distance + 0.04
                const weightA = 1 / (1 + a.strength * 3)
                const weightB = 1 / (1 + b.strength * 3)
                const shareA = weightA / (weightA + weightB)
                shift(
                  a,
                  (nx / normal) * correction * shareA,
                  (ny / normal) * correction * shareA
                )
                shift(
                  b,
                  (-nx / normal) * correction * (1 - shareA),
                  (-ny / normal) * correction * (1 - shareA)
                )
                contacts++
              }
            }
            if (!contacts) break
          }
          bodies.forEach((body) => {
            if (
              Math.abs(body.x) + Math.abs(body.y) + Math.abs(body.scale - 1) <
              0.012
            ) {
              body.x = 0
              body.y = 0
              body.scale = 1
              body.shape.style.removeProperty('transform')
              return
            }
            moving = true
            const localX = (body.x * body.cos + body.y * body.sin) / body.unit
            const localY = (-body.x * body.sin + body.y * body.cos) / body.unit
            body.shape.style.transform =
              'translate(' +
              localX +
              'px, ' +
              localY +
              'px) scale(' +
              body.scale +
              ')'
          })
          return moving
        }
        const influence = (time) => {
          if (reducedMotion.matches) return
          if (time - lastUpdate > 32) {
            lastUpdate = time
            if (logo && hovering) {
              const bounds = logo.getBoundingClientRect()
              updateLens(bounds)
              const dx = Math.max(
                bounds.left - pointer.x,
                0,
                pointer.x - bounds.right
              )
              const dy = Math.max(
                bounds.top - pointer.y,
                0,
                pointer.y - bounds.bottom
              )
              const proximity = Math.max(0, 1 - Math.hypot(dx, dy) / 65)
              setLogoTarget(proximity * proximity * (3 - 2 * proximity))
            }
            const moving = repelCurves()
            if (!hovering && !moving) {
              frame = 0
              return
            }
          }
          frame = requestAnimationFrame(influence)
        }
        host.addEventListener(
          'pointermove',
          (event) => {
            if (!finePointer.matches || reducedMotion.matches) return
            pointer = { x: event.clientX, y: event.clientY }
            if (!hovering) {
              hovering = true
              frame = requestAnimationFrame(influence)
            }
          },
          { passive: true }
        )
        host.addEventListener('pointerleave', reset)
        host.addEventListener('pointercancel', reset)
        reducedMotion.addEventListener('change', reset)
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) reset()
        })
        new ResizeObserver(resize).observe(host)
        new IntersectionObserver(([entry]) => {
          track.style.animationPlayState = entry.isIntersecting
            ? 'running'
            : 'paused'
          if (!entry.isIntersecting) reset()
        }).observe(host)
      })
    })
    .catch(() => {
      // Retain the existing static background if the asset cannot load.
    })
}
